import { Component, OnInit } from '@angular/core';
import { BalanceQuery, config, MemberCard, MemberCardQuery, MemberDetails, MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-member-card',
  templateUrl: './member-card.component.html',
  styleUrls: ['./member-card.component.scss'],
})
export class MemberCardComponent implements OnInit {
  memberCard$: Observable<MemberCard | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  ecash$: Observable<number | undefined>;

  constructor(private memberCardQuery: MemberCardQuery, private memberQuery: MemberQuery, private balanceQuery: BalanceQuery) {}

  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
  }
}
